import { memo, ReactElement, useMemo, ReactNode } from "react";
import "./index.scss";

export interface CheckboxProps {
    name?: string;
    value?: boolean;
    label?: ReactNode;
    disabled?: boolean;
    hidden?: boolean;
    onChange?: (value: boolean) => void;
    additionalInfo?: ReactElement;
    error?: boolean;
    validationError?: string;
    formatValue?: (value: any) => boolean;
}

export const Checkbox = memo((props: CheckboxProps) => {
    const {
        name,
        label,
        disabled,
        hidden,
        onChange,
        value,
        additionalInfo,
        error,
        validationError,
        formatValue
    } = props;

    const handleChange = (value): void => {
        if (onChange) onChange(value);
    };

    const fieldValue = useMemo(() => formatValue ? formatValue(value) : value, [value])

    return (
        <div className={`checkbox`} hidden={hidden}>
            <div className={'checkbox__items'}>
                <input type={'checkbox'}
                    id={name}
                    name={name}
                    checked={fieldValue}
                    disabled={disabled}
                    className={"checkbox__input"}
                    onChange={() => handleChange(!fieldValue)}
                />

                {label && (
                    <label htmlFor={name} className={'checkbox__label'}>{label}
                        {additionalInfo}
                    </label>
                )}
            </div>
            {error && (
                <div className='checkbox__error'>{validationError}</div>
            )}
        </div>
    )
});